import React from 'react';
import s from './ModalFooterDivider.scss';
/** A divider for use with our `<ModalFooter />` */ const ModalFooterDivider = ()=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root'],
        role: "presentation"
    });
};
ModalFooterDivider.displayName = 'ModalFooterDivider';
export default ModalFooterDivider;
